import { $el, $elParent } from 'src/scripts/utils/utils'
import { showElement } from '../../utils/dom'
import { SidebarFilters } from './sidebar-filters'
import { ShopComponent } from '.'

const FILTER_REMOVE_BUTTON_SELECTOR = 'filter-remove-btn'
const SHOP_SELECTOR = 'shop-component'

export class SidebarFiltersMobile extends SidebarFilters {
  change(): void {
    const shop: ShopComponent = $elParent(SHOP_SELECTOR, this)

    if (shop) {
      this.createQuery()

      const preparedUrl = `${window.location.pathname}?${
        shop.formatParams(this.searchParams) || ''
      }`

      shop.updateFilters(preparedUrl)
      this.setButtonForReset()
    }
  }

  setButtonForReset(): void {
    const button = $el(FILTER_REMOVE_BUTTON_SELECTOR, this.element)

    if (button) {
      const isHidden = button.classList.contains('hidden')

      if (isHidden) {
        showElement(button)
      }
    }
  }
}
